export const environment = {
    production: false,

    urlApi: "https://qa-bff-iregistro.iconstruye.cl/registro",
    urlApiSSO: "https://qa-api-login.azurewebsites.net",
    cookieDomain: "iconstruye.cl",
    newRelic: '',
    gtmId: 'GTM-KZ93DWH',
    ga4Id: 'G-HQX7WQH7RN'
};
